var _ellipse, _ellipse2, _circle, _circle2, _path, _path2, _circle3, _circle4, _path3, _path4, _path5, _line, _line2, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChickenEnhanced(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chickenGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1DD3B0",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00D4FF",
      stopOpacity: 0.3
    }
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 38,
    rx: 16,
    ry: 18,
    fill: "url(#chickenGradient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 38,
    rx: 16,
    ry: 18,
    stroke: "#1DD3B0",
    strokeWidth: 2,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 20,
    r: 8,
    fill: "url(#chickenGradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 20,
    r: 8,
    stroke: "#1DD3B0",
    strokeWidth: 2,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 28 14 Q 30 8 32 12 Q 34 8 36 14",
    stroke: "#FFB800",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 32 26 Q 28 28 30 32",
    stroke: "#FFB800",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 20,
    r: 2,
    fill: "#00D4FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 19.5,
    r: 0.8,
    fill: "#E8EAED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 38 20 L 44 19 L 38 22 Z",
    fill: "#FFB800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 44 36 Q 48 38 46 42",
    stroke: "#1DD3B0",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 44 40 Q 46 42 44 44",
    stroke: "#1DD3B0",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 54,
    x2: 26,
    y2: 60,
    stroke: "#FFB800",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 54,
    x2: 38,
    y2: 60,
    stroke: "#FFB800",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 22 60 L 26 60 L 30 60",
    stroke: "#FFB800",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 34 60 L 38 60 L 42 60",
    stroke: "#FFB800",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 18 34 Q 12 32 14 28",
    stroke: "#1DD3B0",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 18 38 Q 10 38 12 34",
    stroke: "#1DD3B0",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 18 42 Q 12 44 14 46",
    stroke: "#1DD3B0",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenEnhanced);
export default __webpack_public_path__ + "static/media/chicken-enhanced.907244634289f7124db887da74e47ad7.svg";
export { ForwardRef as ReactComponent };